import config from '../../../config';
import LiveDocumentTypeService from './LiveDocumentTypeService';
import FakeDocumentTypeService from './FakeDocumentTypeService';
export const documentTypeService = config.offline ? new FakeDocumentTypeService() : new LiveDocumentTypeService();